<div
  [ngClass]="errorState || error ? 'idp-form-grouped--error' : ''"
  class="idp-form-grouped"
>
  <idp-action-label
    (clicked)="notify('top')"
    (iconClicked)="iconClicked()"
    *ngIf="topLabelText || labelMargin"
    [displayFlex]="displayFlex"
    [emphasis]="hasValue ? 'dark' : ''"
    [errorState]="errorState || false"
    [helpIcon]="helpIcon"
    [icon]="topLabelIcon"
    [labelId]="'top_' + id"
    [ngClass]="{ 'idp-molecule-calendar-dropdown__moveTop': open }"
    [role]="open ? 'selected' : 'action'"
    [text]="topLabelText"
    class="idp-molecule-calendar-dropdown__label idp-molecule-calendar-dropdown__label--top"
  ></idp-action-label>
  <div
    (focusin)="dropdownWrapperChangeFocused(true)"
    (focusout)="dropdownWrapperChangeFocused(false); checkFocused()"
    (keydown.enter)="toggle($event)"
    (mousedown)="toggle($event)"
    [class.idp-molecule-calendar-dropdown--add-margin]="addMargin"
    [ngClass]="{
      'idp-molecule-calendar-dropdown--error': errorState,
      'idp-molecule-calendar-dropdown--disabled': disabled
    }"
    class="idp-molecule-calendar-dropdown"
    role="presentation"
    tabindex="0"
  >
    <div
      [attr.aria-describedby]="'idp-' + id + '__selected'"
      [attr.aria-expanded]="open ? 'true' : 'false'"
      [attr.aria-labelledby]="
        'textbox_' + id + ' unavailable_label_' + id + ' readonly_label_' + id
      "
      [attr.data-selected-value]="selectedDate"
      [id]="'idp-' + id + '__selected'"
      [ngClass]="
        open || focused
          ? 'idp-molecule-calendar-dropdown__focused-selected'
          : ''
      "
      aria-haspopup="true"
      class="idp-molecule-calendar-dropdown__selected"
      role="button"
    >
      <span
        [attr.aria-label]="
          topLabelText
            ? topLabelText
            : selectedDate
            ? setDateFormat()
            : placeholderText
        "
        id="textbox_{{ id }}"
        role="textbox"
      >
        {{ selectedDate ? setDateFormat() : placeholderText }}
      </span>
      <span
        *ngIf="selectedDate && selectedDate === '--'"
        class="sr-only"
        id="unavailable_label_{{ id }}"
      >
        unavailable
      </span>
      <span *ngIf="disabled" class="sr-only" id="readonly_label_{{ id }}">
        read only
      </span>
    </div>
    <idp-error-tooltip
      *ngIf="dropdownWrapperFocused && (errorState || error)"
      [arrowPosition]="arrowPosition"
      [errorMessage]="errorMessage"
      [icon]="true"
    ></idp-error-tooltip>
    <svg
      [class.idp-molecule-calendar-dropdown__arrow--disabled]="disabled"
      class="idp-molecule-calendar-dropdown__arrow"
      disabled="disabled"
      fill="none"
      height="22"
      viewBox="0 0 24 22"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 20.4392V3.63923C24 3.63923 23.9467 2.89257 23.0933 2.7859C22.1867 2.7859 19.4133 2.7859 19.4133
              2.7859V1.3459C19.4133 1.3459 19.2 0.599233 18.4 0.599233C17.4933 0.599233 17.3867 1.3459 17.3867
              1.3459V2.83923H13.0133V1.3459C13.0133 1.3459 12.8533 0.599233 12 0.599233C11.1467 0.599233 10.9867
              1.3459 10.9867 1.3459V2.83923H6.72V1.3459C6.72 1.3459 6.50667 0.652566 5.70667 0.599233C4.90667
              0.545899 4.64 1.3459 4.64 1.3459V2.83923C4.64 2.83923 1.76 2.83923 0.96 2.83923C0.106667 2.83923 0
              3.7459 0 3.7459V20.3326C0 20.3326 0.106667 21.1859 0.746667 21.2392C7.14667 21.2392 18.6667 21.2392
              22.5067 21.2392C24.0533 21.2392 24 20.4392 24 20.4392ZM21.9733 19.2126H2.02667V9.5059H21.9733V19.2126ZM21.9733
              7.47923H2.02667V4.8659H21.9733V7.47923Z"
        fill="#0B1F66"
      />
    </svg>
    <idp-calendar-single
      (hasFocus)="calendarFocusChanges($event); checkFocused()"
      (open)="open = $event; reFocus()"
      (value)="setSelectedDate($event?.value || '')"
      [anchorDate]="anchorDate || ''"
      [class.idp-molecule-calendar-dropdown__calendar--close]="!open"
      [disableFuture]="disableFuture"
      [disablePrevious]="disablePrevious"
      [errorMessage]="errorMessage"
      [errorState]="errorState"
      [inDropdown]="true"
      [monthOffsetValue]="monthOffsetValue"
      [numbrOfFutureDays]="numbrOfFutureDays"
      [numbrOfPrevDays]="numbrOfPrevDays"
      [openCalendarFlag]="open"
      [selectedDate]="selectedDate"
      [showCloseButton]="false"
      [showFooter]="true"
      [hideClearButton]="hideClearButton"
      [hideDoneButton]="hideDoneButton"
    ></idp-calendar-single>
  </div>

  <idp-action-label
    (clicked)="notify('bottom')"
    (iconClicked)="iconClicked()"
    *ngIf="bottomLabelText"
    [displayFlex]="displayFlex"
    [icon]="bottomLabelIcon"
    [text]="bottomLabelText"
    aria-hidden="true"
    class="idp-molecule-calendar-dropdown__label idp-molecule-calendar-dropdown__label--bottom"
    role="action"
  ></idp-action-label>
</div>
